var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"block_left"},[_c('div',{staticClass:"svg",domProps:{"innerHTML":_vm._s(_vm.svg)}}),_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.lessonHeader)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }